import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import * as actions from '../../../redux/actions/purchasingHistory';
import style from './PurchasingHistorySearchResult.module.scss';
import { IState } from '../../../types/interfaces';
import { IPurchase } from '../../../redux/reducers/purchasingHistory';
import Pagination from '../Pagination';
import api from '../../../helpers/api';
import ServerError from '../Errors/ServerError';
import NotFoundWithMargin from '../Errors/NotFoundWithMargin';

interface IProps {
  purchasingHistory: any;
  setPurchasingHistory: Function;
  inn: string;
  errors: string;
  // data_complaints: any;
  // data_contracts: any;
}

export const toDivide = (num: number) => {
  const int = String(Math.trunc(num));
  if (int.length <= 3) return int;
  let space = 0;
  let number = '';

  for (let i = int.length - 1; i >= 0; i--) {
    if (space === 3) {
      number = ` ${number}`;
      space = 0;
    }
    number = int.charAt(i) + number;
    space += 1;
  }

  return number;
};

// payload: {by_requisites: {current_year_count: 0, previous_year_count: 0, items: []},…}
// by_name: {current_year_count: 0, previous_year_count: 2,…}
// current_year_count: 0
// items: [{complainant_name: "ООО "РЕГИОН-СЕРВИС"", complainant_inn: null, complainant_kpp: null,…},…]
// 0: {complainant_name: "ООО "РЕГИОН-СЕРВИС"", complainant_inn: null, complainant_kpp: null,…}
// complainant_inn: null
// complainant_kpp: null
// complainant_name: "ООО \"РЕГИОН-СЕРВИС\""
// filed_at: "2020-07-17"
// procedure_description: "Закупка комплекса рентгеновского диагностического на три рабочих места для нужд ГБУЗ ВО \"Петушинская районная больница\""
// procedure_registry_id: "0128200000120003561"
// registry_id: null
// 1: {complainant_name: "ООО "РЕГИОН-СЕРВИС"", complainant_inn: null, complainant_kpp: null,…}
// complainant_inn: null
// complainant_kpp: null
// complainant_name: "ООО \"РЕГИОН-СЕРВИС\""
// filed_at: "2020-01-16"
// procedure_description: "Изделия медицинского назначения перевязочные"
// procedure_registry_id: "0373100045919000130"
// registry_id: null
// previous_year_count: 2
// by_requisites: {current_year_count: 0, previous_year_count: 0, items: []}
// current_year_count: 0
// items: []
// previous_year_count: 0

const PurchasingHistorySearchResult = ({
  purchasingHistory,
  setPurchasingHistory,
  inn,
  errors,
}: // data_complaints,
// data_contracts,
IProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  // data: ["NOT_FOUND"]
  // Если у нас в data лежит 1 элемент и это "NOT_FOUND", выводим текст :  Отсутствует история участия по запрашиваемому контрагенту
  const noHistory = purchasingHistory?.data[0] === 'NOT_FOUND' && purchasingHistory?.data?.length !== 0;

  // data: []
  // Если у нас в data ничего не лежит, то выводим текст : Контрагент не найден
  const noAgent = purchasingHistory?.data[0] !== 'NOT_FOUND' && purchasingHistory?.data?.length === 0;

  return (
    <>
      {errors === 'NOT_FOUND' && <NotFoundWithMargin />}
      {errors && errors !== 'NOT_FOUND' && <ServerError />}
      {!errors && purchasingHistory?.data ? (
        <>
          {isLoading ? (
            <div className={style.spin}>
              <Spin />
            </div>
          ) : (
            <div>
              <table className={style.table}>
                <thead className={style.head}>
                  <tr className={style.headRow}>
                    <th>№ закупки</th>
                    <th>Организатор</th>
                    <th>Дата публикации</th>
                    <th>Сумма НМЦ</th>
                    <th>Для МСП</th>
                    <th>ОКПД2</th>
                    <th>Регион поставки</th>
                    <th>Победитель</th>
                    {/* <th>Жалобы по ИНН</th>
                    <th>Жалобы по наименованию</th> */}
                    {/* <th>Жалобы</th>
                    <th>Кол-во закл. контрактов</th>
                    <th>Средний % снижения</th> */}
                  </tr>
                </thead>

                {noAgent && (
                  <tbody className={style.body}>
                    <tr className={style.firstRow}>
                      <td colSpan={8}>Отсутствует история участия по запрашиваемому контрагенту</td>
                    </tr>
                  </tbody>
                )}

                {noHistory && (
                  <tbody className={style.body}>
                    <tr className={style.firstRow}>
                      <td colSpan={8}>Контрагент не найден</td>
                    </tr>
                  </tbody>
                )}
                {/* 
                {(purchasingHistory?.data[0] === 'NOT_FOUND' || purchasingHistory?.data?.length === 0) && (
                  <tbody className={style.body}>
                    <tr className={style.firstRow}>
                      <td colSpan={8}>История контрагента пуста</td>
                    </tr>
                  </tbody>
                )} */}

                {!noHistory &&
                  !noAgent &&
                  purchasingHistory?.data.map((purchase: IPurchase, index: number) => {
                    let isWinner = '';

                    if (purchase.is_winner !== null) {
                      if (purchase.is_winner) {
                        isWinner = 'Да';
                      } else {
                        isWinner = 'Нет';
                      }
                    } else {
                      isWinner = 'Нет данных';
                    }
                    const outsideURL =
                      purchase?.short_title.length === 11
                        ? `https://zakupki.gov.ru/223/purchase/public/purchase/info/common-info.html?regNumber=${purchase.short_title}`
                        : `https://zakupki.gov.ru/epz/order/notice/ea44/view/common-info.html?regNumber=${purchase.short_title}`;

                    return (
                      <tbody className={style.body} key={index.toString()}>
                        <tr className={style.firstRow}>
                          <td colSpan={8}>
                            <div className={style.group}>
                              <p className={style.title}>{purchase.title}</p>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={purchase.url ? purchase.url : outsideURL}
                                type="button"
                                className={style.btn}
                              >
                                Просмотр
                              </a>
                            </div>
                          </td>
                        </tr>
                        <tr className={style.secondRow}>
                          <td>{purchase.short_title}</td>
                          <td>
                            {purchase?.buyer?.short_name ? purchase?.buyer?.short_name : purchase?.buyer?.name}
                            <br />
                            <b>ИНН</b> {purchase?.buyer?.inn} <b>КПП</b> {purchase?.buyer?.kpp}
                          </td>
                          <td>{purchase.published_at}</td>
                          <td>{`${toDivide(Math.round(+purchase.nmc))} `}&#8381;</td>
                          <td>{purchase.is_msp ? 'Да' : 'Нет'}</td>
                          <td>
                            {purchase.okpd2_codes.map((el: string) => (
                              <p key={el}>{el}</p>
                            ))}
                          </td>
                          <td>
                            {purchase?.regions?.map((region) => (
                              <p key={region}>{region}</p>
                            ))}
                          </td>
                          <td>{isWinner}</td>
                          {/* <td>{purchase?.complaints?.count_by_requisites}</td>
                          <td>{purchase?.complaints?.count_by_name}</td> */}
                          {/* <td>0</td> */}
                        </tr>
                      </tbody>
                    );
                  })}
              </table>
            </div>
          )}
        </>
      ) : null}

      {purchasingHistory?.last_page >= 0 && (
        <div className={style.pagination}>
          <Pagination
            lastPage={purchasingHistory.last_page}
            page={currentPage}
            setPage={setCurrentPage}
            searchId={0}
            inn={inn}
            setData={async (page: number) => {
              setIsLoading(true);
              const data = await api.getPurchaseHistory(inn, '', page);
              await setPurchasingHistory(data);
              setIsLoading(false);
            }}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  purchasingHistory: state.purchasingHistory.data,
  data_contracts: state.purchasingHistory.data_contracts,
  data_complaints: state.purchasingHistory.data_complaints,
  inn: state.purchasingHistory.inn,
  errors: state.purchasingHistory.errors,
});

export default connect(mapStateToProps, actions)(PurchasingHistorySearchResult);
